import i18n from 'i18next';
import { Dispatch } from 'redux';
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest
} from 'src/store/api-handler';
import { MethodDto, MethodEditDto } from 'src/store/methods/method';
import { alertError, alertSuccess } from '../alerts/alerts.actions';
import { requestBegin, requestEnd } from '../requests/requests.actions';

export enum MethodTypes {
  FetchAll = 'methods/FetchAll',
  Add = 'methods/Add',
  Update = 'methods/Update',
  Delete = 'methods/Delete',
  Failure = 'methods/Failure'
}

export type MethodAction =
  | { type: MethodTypes.FetchAll; methods: MethodDto[] }
  | { type: MethodTypes.Add; method: MethodDto }
  | { type: MethodTypes.Update; method: MethodDto }
  | { type: MethodTypes.Delete; method: MethodDto }
  | { type: MethodTypes.Failure; errors: any };

export const actionCreators = {
  fetchMethods: (methods: MethodDto[]): MethodAction => ({
    type: MethodTypes.FetchAll,
    methods
  }),
  addMethod: (method: MethodDto): MethodAction => ({
    type: MethodTypes.Add,
    method
  }),
  updateMethod: (method: MethodDto): MethodAction => ({
    type: MethodTypes.Update,
    method
  }),
  deleteMethod: (method: MethodDto): MethodAction => ({
    type: MethodTypes.Delete,
    method
  }),
  methodRequestFailure: (errors: any): MethodAction => ({
    type: MethodTypes.Failure,
    errors
  })
};

export const fetchMethods = () => {
  return async (dispatch: Dispatch) => {
    dispatch(requestBegin(MethodTypes.FetchAll));
    const { ok, data, error } = await getRequest<MethodDto[]>('/methods');
    dispatch(requestEnd(MethodTypes.FetchAll));
    return ok
      ? dispatch(actionCreators.fetchMethods(data))
      : dispatch(actionCreators.methodRequestFailure(error));
  };
};

export const createMethod = (method: MethodEditDto) => {
  return async (dispatch: Dispatch) => {
    const { ok, error } = await postRequest('/methods', method);

    if (ok) {
      return dispatch(alertSuccess(i18n.t('method.created')));
    }

    dispatch(alertError(error?.errors?.detail ?? i18n.t('create.failed')));
    return dispatch(actionCreators.methodRequestFailure(error));
  };
};

export const editMethod = (id: number, method: MethodEditDto) => {
  return async (dispatch: Dispatch) => {
    const { ok, error } = await putRequest(`/methods/${id}`, method);

    if (ok) {
      return dispatch(alertSuccess(i18n.t('method.updated')));
    }

    dispatch(alertError(error?.errors?.detail ?? i18n.t('save.failed')));
    return dispatch(actionCreators.methodRequestFailure(error));
  };
};

export const deleteMethod = (id: number, method: MethodDto) => {
  return async (dispatch: Dispatch) => {
    const { ok, error } = await deleteRequest(`/methods/${id}`, method);

    if (ok) {
      dispatch(alertSuccess(i18n.t('method.deleted')));
      return actionCreators.deleteMethod(method);
    }

    dispatch(alertError(error?.errors?.detail ?? i18n.t('remove.failed')));
    return dispatch(actionCreators.methodRequestFailure(error));
  };
};
